import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import {
  Layout, Card, Form, Input, Select, DatePicker, Button, Table, 
  Space, Divider, Drawer, Radio, Badge, Typography,
  message, Descriptions, Row, Col, Upload, Alert, Tag, Modal, Spin, Empty
} from 'antd';
import {
  SearchOutlined, ReloadOutlined, PlusOutlined, InfoCircleOutlined,
  HistoryOutlined,
  CloudUploadOutlined, DownloadOutlined, UploadOutlined, 
} from '@ant-design/icons';

const { Content } = Layout;
const { Title, Text } = Typography;
const { RangePicker } = DatePicker;
const { Option } = Select;

// TODO: 联调时替换为接口数据
const MOCK_BATCH_OPERATIONS = [
  {
    id: 1, batchNo: 'PC20260300239757', enterpriseName: '东莞康林物联网有限公司', enterpriseId: 'JGSf0Nd7',
    appName: 'CONRING-iOS', appId: 'YBvr4vc', packageName: '超高清录像 A A', packageId: 'PKG-7728-XA',
    opType: 'grant', effectiveType: 'immediate', direction: 'device', idType: 'license',
    memo: '--', operator: 'production_test', time: '2026-03-17 11:42:11',
    sourceType: 'manual', sourceOrderName: null, sourceOrderId: null,
    batchStatus: 'normal', countTotal: 1, countOpened: 1, countWaiting: 0, countFailed: 0, countCancelled: 0,
  },
  {
    id: 2, batchNo: 'PC20260301156261', enterpriseName: '东莞康林物联网有限公司', enterpriseId: 'JGSf0Nd7',
    appName: '牵心Pro', appId: 'HF93823', packageName: '超高清录像 A', packageId: 'PKG-1156-XB',
    opType: 'grant', effectiveType: 'later', direction: 'device', idType: 'did',
    memo: '戴首天操作_康林云存赠送_20...', operator: 'daishoutian', time: '2026-03-16 11:42:11',
    sourceType: 'manual', sourceOrderName: null, sourceOrderId: null,
    batchStatus: 'normal', countTotal: 408, countOpened: 300, countWaiting: 80, countFailed: 28, countCancelled: 0,
  },
  {
    id: 3, batchNo: 'PC20260302042619', enterpriseName: '东莞康林物联网有限公司', enterpriseId: 'JGSf0Nd7',
    appName: 'CONRING-iOS', appId: 'YBvr4vc', packageName: '超高清AI录像AA', packageId: 'PKG-0426-XC',
    opType: 'grant', effectiveType: 'later', direction: 'user', idType: 'uid',
    memo: '补偿用户因系统升级导致的数据丢失', operator: 'admin', time: '2026-03-15 11:42:11',
    sourceType: 'manual', sourceOrderName: null, sourceOrderId: null,
    batchStatus: 'normal', countTotal: 1, countOpened: 0, countWaiting: 1, countFailed: 0, countCancelled: 0,
  },
  {
    id: 4, batchNo: 'PC20260415001001', enterpriseName: '东莞康林物联网有限公司', enterpriseId: 'JGSf0Nd7',
    appName: 'CONRING-iOS', appId: 'YBvr4vc', packageName: '全天录像 30天循环', packageId: 'PKG-9912-JS',
    opType: 'grant', effectiveType: 'immediate', direction: 'device', idType: 'license',
    memo: '按工单批量赠送-华东批次', operator: 'admin', time: '2026-04-15 09:30:00',
    sourceType: 'order', sourceOrderName: '2025Q4华东批次-摄像头A', sourceOrderId: 'WO-20251008-0012',
    batchStatus: 'normal', countTotal: 500, countOpened: 480, countWaiting: 0, countFailed: 20, countCancelled: 0,
  },
  {
    id: 5, batchNo: 'PC20260304065624', enterpriseName: '东莞康林物联网有限公司', enterpriseId: 'JGSf0Nd7',
    appName: '牵心Pro', appId: 'HF93823', packageName: 'AI人脸识别包月', packageId: 'PKG-2233-AI',
    opType: 'grant', effectiveType: 'immediate', direction: 'device', idType: 'did',
    memo: '批量测试开通', operator: 'test_user', time: '2026-03-13 15:30:00',
    sourceType: 'manual', sourceOrderName: null, sourceOrderId: null,
    batchStatus: 'normal', countTotal: 120, countOpened: 120, countWaiting: 0, countFailed: 0, countCancelled: 0,
  },
  {
    id: 6, batchNo: 'PC20260701000123', enterpriseName: '东莞康林物联网有限公司', enterpriseId: 'JGSf0Nd7',
    appName: '牵心Pro', appId: 'HF93823', packageName: '超高清录像 A', packageId: 'PKG-1156-XB',
    opType: 'close', deviceCount: 45, direction: 'device', idType: 'did',
    memo: '戴首天操作_批量关闭过期套餐', operator: 'daishoutian', time: '2026-07-01 14:30:00',
    sourceType: null, sourceOrderName: null, sourceOrderId: null,
    batchStatus: 'normal',
  },
  {
    id: 7, batchNo: 'PC20260702000567', enterpriseName: '东莞康林物联网有限公司', enterpriseId: 'JGSf0Nd7',
    appName: 'CONRING-iOS', appId: 'YBvr4vc', packageName: '全天录像 30天循环', packageId: 'PKG-9912-JS',
    opType: 'close', deviceCount: 200, direction: 'device', idType: 'license',
    memo: '售后维权批量关闭', operator: 'admin', time: '2026-07-02 09:15:00',
    sourceType: null, sourceOrderName: null, sourceOrderId: null,
    batchStatus: 'normal',
  },
  {
    id: 8, batchNo: 'PC20260512001888', enterpriseName: '东莞康林物联网有限公司', enterpriseId: 'JGSf0Nd7',
    appName: 'CONRING-iOS', appId: 'YBvr4vc', packageName: '超高清录像 A', packageId: 'PKG-1156-XB',
    opType: 'grant', effectiveType: 'later', direction: 'device', idType: 'license',
    memo: '售后补偿-已撤回', operator: 'admin', time: '2026-05-12 10:00:00',
    sourceType: 'manual', sourceOrderName: null, sourceOrderId: null,
    batchStatus: 'cancelled', countTotal: 50, countOpened: 0, countWaiting: 0, countFailed: 0, countCancelled: 50,
  },
];

const MOCK_DETAIL_DATA = [
  { id: 1, batchId: 1, orderNo: 'C20260126065748-01-XXX', idType: 'License', license: 'licensedemo', did: 'DIDdemo', uid: 'UIDdemo', account: 'xx-xxxxxxxx', status: 'opened', effectiveType: 'immediate' },
  { id: 2, batchId: 2, orderNo: '', idType: 'DID', license: '--', did: 'DIDdemo', uid: 'UIDdemo', account: 'xx-xxxxxxxx', status: 'opened', effectiveType: 'later' },
  { id: 3, batchId: 2, orderNo: 'C20260126065748-03-XXX', idType: 'UID', license: '--', did: '--', uid: 'UIDdemo', account: '--', status: 'waiting', effectiveType: 'later' },
  { id: 4, batchId: 2, orderNo: '', idType: '账号', license: 'licensedemo', did: 'DIDdemo', uid: 'UIDdemo', account: 'xx-xxxxxxxx', status: 'waiting', effectiveType: 'later' },
  { id: 5, batchId: 2, orderNo: '', idType: 'License', license: 'licensedemo', did: 'DIDdemo', uid: 'UIDdemo', account: 'xx-xxxxxxxx', status: 'failed', effectiveType: 'later' },
  { id: 6, batchId: 1, orderNo: '', idType: 'License', license: 'licensedemo2', did: 'DIDdemo2', uid: 'UIDdemo2', account: 'xx-xxxxxxxx', status: 'failed', effectiveType: 'immediate' },
  { id: 7, batchId: 8, orderNo: '', idType: 'License', license: 'licensedemo3', did: 'DIDdemo3', uid: 'UIDdemo3', account: 'xx-xxxxxxxx', status: 'cancelled', effectiveType: 'later' },
];

// TODO: 联调时替换为接口数据 — 本企业工单
const MOCK_WORK_ORDERS = [
  { id: 'WO-20251008-0012', name: '2025Q4华东批次-摄像头A', productName: '智能摄像头 Pro', productId: 'PID-3382', status: 'producing', licenseTotal: 500, produced: 320, pending: 180 },
  { id: 'WO-20251020-0038', name: '华南外协-门磁', productName: '智能门磁 S1', productId: 'PID-5510', status: 'done', licenseTotal: 2000, produced: 2000, pending: 0 },
  { id: 'WO-20260301-0015', name: '2026春季批次-可视门铃', productName: '可视门铃 Pro', productId: 'PID-7723', status: 'producing', licenseTotal: 800, produced: 600, pending: 200 },
  { id: 'WO-20260410-0021', name: '外协工厂-烟雾报警器', productName: '烟雾报警器 NB-IoT', productId: 'PID-1155', status: 'pending', licenseTotal: 1500, produced: 0, pending: 1500 },
  { id: 'WO-NEW-20260521-MOCK', name: '【Mock新工单】来自创建工单页面', productName: '（由创建工单传入）', productId: 'PROD_NEW', status: 'producing', licenseTotal: 500, produced: 0, pending: 500 },
];

const generateMockLicenses = (count, prefix) => {
  return Array.from({ length: count }, (_, i) => ({
    id: i + 1,
    licenseId: `${prefix}${String(i + 1).padStart(4, '0')}`,
    status: i < count * 0.7 ? 'produced' : 'pending',
  }));
};

const MOCK_LICENSE_MAP = {
  'WO-20251008-0012': generateMockLicenses(500, 'ENT00120251008'),
  'WO-20251020-0038': generateMockLicenses(2000, 'ENT00120251020'),
  'WO-20260301-0015': generateMockLicenses(800, 'ENT00120260301'),
  'WO-20260410-0021': generateMockLicenses(1500, 'ENT00120260410'),
  'WO-NEW-20260521-MOCK': generateMockLicenses(500, 'ENTNEW20260521'),
};

// Select 选项格式化
const formatWorkOrderOption = (wo) => ({
  value: wo.id,
  label: `${wo.id} | ${wo.name} | ${wo.productName} | License: ${wo.licenseTotal}个`,
});

// ═══════════════════════════════
//  CSV 下载工具函数
// ═══════════════════════════════
const downloadCSV = (filename, rows) => {
  const bom = '\uFEFF';
  const csvContent = bom + rows.map(row => row.join(',')).join('\n');
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
};

const timestamp = () => {
  const now = new Date();
  const pad = (n) => String(n).padStart(2, '0');
  return `${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}_${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}`;
};

// ═══════════════════════════════
//  Mock 校验数据生成
// ═══════════════════════════════
const makeMockIllegalItems = (prefix, count) => Array.from({ length: count }, (_, i) => `${prefix}-illegal-${String(i + 1).padStart(3, '0')}`);
const makeMockValidItems = (prefix, count) => Array.from({ length: count }, (_, i) => `${prefix}-valid-${String(i + 1).padStart(3, '0')}`);
const makeMockDupItems = (prefix, count) => Array.from({ length: count }, (_, i) => ({ id: `${prefix}-dup-${String(i + 1).padStart(3, '0')}`, existingCount: i + 1 }));

const PackageGift = () => {
  const [form] = Form.useForm();
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [currentRow, setCurrentRow] = useState(null);

  // ═══════════ 取消开通（撤回）状态 ═══════════
  const [batchList, setBatchList] = useState(MOCK_BATCH_OPERATIONS);
  const [detailList, setDetailList] = useState(MOCK_DETAIL_DATA);
  const [selectedCancelKeys, setSelectedCancelKeys] = useState([]);
  
  const [addDrawerVisible, setAddDrawerVisible] = useState(false);
  const [direction, setDirection] = useState('device');
  const [idType, setIdType] = useState('license');
  const [handleMethod, setHandleMethod] = useState('manual');
  const [addForm] = Form.useForm();

  // 按工单选择状态
  const [selectedWorkOrderId, setSelectedWorkOrderId] = useState(null);
  const [licenseList, setLicenseList] = useState([]);
  const [licenseLoading, setLicenseLoading] = useState(false);
  const [confirmModalVisible, setConfirmModalVisible] = useState(false);

  // ═══════════ 校验流水线状态 ═══════════
  const [validating, setValidating] = useState(false);             // 校验中 loading
  const [submitting, setSubmitting] = useState(false);            // 开通中 loading
  const [validationModal, setValidationModal] = useState(null);   // 'illegalDevice' | 'illegalUser' | 'duplicate' | null
  const [validationData, setValidationData] = useState(null);     // { illegalItems[], validItems[], ... }

  // ═══════════ 关闭套餐 ═══════════
  const [closeDrawerVisible, setCloseDrawerVisible] = useState(false);
  const [closeTargetType, setCloseTargetType] = useState('device');
  const [closeIdType, setCloseIdType] = useState('license');
  const [closeTargetId, setCloseTargetId] = useState('');
  const [closeTargetInfo, setCloseTargetInfo] = useState(null);
  const [closeQueryResult, setCloseQueryResult] = useState([]);
  const [closeQueryLoading, setCloseQueryLoading] = useState(false);
  const [closeSelectedKeys, setCloseSelectedKeys] = useState([]);

  // 模拟查询生效中套餐
  const MOCK_ACTIVE_PACKAGES = [
    { id: 1, packageName: '超高清录像 7天循环', packageId: 'PKG-7728-XA', orderNo: 'C20260316065624', duration: '1年', status: 'active', opType: 'grant', effectiveType: 'immediate', buyTime: '2025-03-16 10:00:00', expireTime: '2026-03-16 10:00:00' },
    { id: 2, packageName: 'AI事件录像', packageId: 'PKG-1156-XB', orderNo: 'C20260317091245', duration: '1个月', status: 'pending', opType: 'grant', effectiveType: 'later', buyTime: '2026-03-17 11:00:00', expireTime: '--' },
    { id: 3, packageName: '全天录像 30天', packageId: 'PKG-0426-XC', orderNo: 'C20260318042619', duration: '3个月', status: 'active', opType: 'grant', effectiveType: 'immediate', buyTime: '2026-01-18 10:00:00', expireTime: '2026-04-18 10:00:00' },
  ];

  const handleCloseQuery = () => {
    if (!closeTargetId.trim()) { message.warning('请输入标识'); return; }
    setCloseQueryLoading(true);
    setTimeout(() => {
      const kw = closeTargetId.trim().toLowerCase();
      if (kw.includes('test')) {
        if (closeTargetType === 'device') {
          setCloseTargetInfo({ did: 'test-DID-12000101c1293f6b', license: 'test-LICS-8827-XABC', enterprise: '东莞康林物联网有限公司', enterpriseId: 'JGSf0Nd7' });
        } else {
          setCloseTargetInfo({ uid: 'test-UID-9921', account: 'test_user' });
        }
        setCloseQueryResult(MOCK_ACTIVE_PACKAGES);
      } else {
        setCloseTargetInfo(null);
        setCloseQueryResult([]);
      }
      setCloseSelectedKeys([]);
      setCloseQueryLoading(false);
    }, 500);
  };

  // 从创建工单页面跳转过来时，自动打开赠送抽屉并预填
  const [searchParams] = useSearchParams();
  useEffect(() => {
    if (searchParams.get('openGift') === '1') {
      // 读取 sessionStorage 中的 mock 工单信息
      const raw = sessionStorage.getItem('giftMockOrder');
      if (raw) {
        try {
          const mockOrder = JSON.parse(raw);
          // 更新 mock 工单数据（让开发人员一眼分辨）
          const idx = MOCK_WORK_ORDERS.findIndex(w => w.id === 'WO-NEW-20260521-MOCK');
          if (idx >= 0) {
            MOCK_WORK_ORDERS[idx] = {
              ...MOCK_WORK_ORDERS[idx],
              name: mockOrder.orderName || '【Mock新工单】',
              productName: mockOrder.productName || '智能摄像机Q1',
              productId: mockOrder.productId || '',
              licenseTotal: mockOrder.licenseTotal || 500,
            };
          }
          // 设置预填值
          setAddDrawerVisible(true);
          setDirection('device');
          setIdType('license');
          setHandleMethod('order');
          setTimeout(() => {
            setSelectedWorkOrderId('WO-NEW-20260521-MOCK');
            handleOrderSelect('WO-NEW-20260521-MOCK');
            // 设置生效方式为后生效
            addForm.setFieldsValue({ effectiveType: 'later' });
            // eslint-disable-next-line
          }, 100);
        } catch { /* ignore */ }
      } else {
        // 无 sessionStorage 数据时使用默认 mock
        setAddDrawerVisible(true);
        setDirection('device');
        setIdType('license');
        setHandleMethod('order');
        setTimeout(() => { setSelectedWorkOrderId('WO-NEW-20260521-MOCK'); handleOrderSelect('WO-NEW-20260521-MOCK'); addForm.setFieldsValue({ effectiveType: 'later' }); }, 100);
      }
      // 清除 URL 参数避免刷新重复触发
      sessionStorage.removeItem('giftMockOrder');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const selectedWorkOrder = MOCK_WORK_ORDERS.find(w => w.id === selectedWorkOrderId);

  const handleMethodChange = (e) => {
    const val = e.target.value;
    setHandleMethod(val);
    if (val !== 'order') {
      setSelectedWorkOrderId(null);
      setLicenseList([]);
    }
    if (val === 'order') {
      addForm.setFieldsValue({ targetIds: undefined });
    }
  };

  const handleOrderSelect = (orderId) => {
    setSelectedWorkOrderId(orderId);
    setLicenseLoading(true);
    setTimeout(() => {
      const licenses = MOCK_LICENSE_MAP[orderId] || [];
      setLicenseList(licenses);
      setLicenseLoading(false);
    }, 300);
  };

  // ════════════════════════════════════════
  //  校验流水线逻辑
  // ════════════════════════════════════════

  // 模拟校验接口 — 根据输入内容决定校验结果
  const runValidation = () => {
    setValidating(true);
    setTimeout(() => {
      const rawInput = addForm.getFieldValue('targetIds') || '';
      const inputLower = rawInput.toLowerCase();
      const hasIllegal = inputLower.includes('illegal');

      if (direction === 'device' && hasIllegal) {
        const illegalItems = makeMockIllegalItems(idType.toUpperCase(), 3);
        const validItems = makeMockValidItems(idType.toUpperCase(), 3);
        setValidationData({
          type: 'device',
          illegalCount: illegalItems.length,
          validCount: validItems.length,
          illegalItems,
          validItems,
        });
        setValidationModal('illegalDevice');
      } else if (direction === 'user' && hasIllegal) {
        const illegalItems = makeMockIllegalItems('USER', 3);
        const validItems = makeMockValidItems('USER', 3);
        setValidationData({
          type: 'user',
          illegalCount: illegalItems.length,
          validCount: validItems.length,
          illegalItems,
          validItems,
        });
        setValidationModal('illegalUser');
      } else if (direction === 'device') {
        // 无非法设备 → 直接校验重复赠送
        runDuplicateCheck(makeMockValidItems(idType.toUpperCase(), 5));
        return;
      } else if (direction === 'user') {
        // 无非法用户 → 直接校验重复赠送
        runDuplicateCheck(makeMockValidItems('USER', 5));
        return;
      }
      setValidating(false);
    }, 800);
  };

  const runDuplicateCheck = (validItems) => {
    const rawInput = addForm.getFieldValue('targetIds') || '';
    const hasDuplicate = rawInput.toLowerCase().includes('dup');
    setValidating(true);
    setTimeout(() => {
      if (hasDuplicate) {
        const dupItems = makeMockDupItems(direction === 'device' ? idType.toUpperCase() : 'USER', 3);
        const cleanItems = validItems.slice(0, 2);
        setValidationData({
          type: direction,
          duplicateCount: dupItems.length,
          cleanCount: cleanItems.length,
          totalCount: dupItems.length + cleanItems.length,
          dupItems,
          cleanItems,
        });
        setValidationModal('duplicate');
      } else {
        // 全部通过 → 直接执行开通
        doGrant();
      }
      setValidating(false);
    }, 600);
  };

  // 处理校验弹窗中的用户选择
  const handleValidationChoice = (choice) => {
    const data = validationData;

    if (choice === 'cancel') {
      setValidationModal(null);
      setValidationData(null);
      return;
    }

    if (choice === 'downloadOnly') {
      const label = data.type === 'user' ? '用户' : '设备';
      const filename = `非法${label}_${timestamp()}.csv`;
      const header = direction === 'device' ? `非法${idType.toUpperCase()}` : '非法用户账号';
      const rows = [[header], ...data.illegalItems.map(item => [item])];
      downloadCSV(filename, rows);
      setValidationModal(null);
      setValidationData(null);
      return;
    }

    if (choice === 'continueValid') {
      // 下载非法 CSV
      const label = data.type === 'user' ? '用户' : '设备';
      const filename = `非法${label}_${timestamp()}.csv`;
      const header = direction === 'device' ? `非法${idType.toUpperCase()}` : '非法用户账号';
      const rows = [[header], ...data.illegalItems.map(item => [item])];
      downloadCSV(filename, rows);
      setValidationModal(null);

      // 进入重复校验
      runDuplicateCheck(data.validItems);
      return;
    }

    if (choice === 'allGrant') {
      // 下载重复 CSV
      const label = data.type === 'user' ? '用户' : '设备';
      const filename = `已赠送${label}_全部开通_${timestamp()}.csv`;
      const rows = [
        ['License', '已赠送次数', '当前赠送'],
        ...data.dupItems.map((item, i) => [(i + 1), item.existingCount, 1]),
        ...data.cleanItems.map((item, i) => [data.dupItems.length + i + 1, 0, 1]),
      ];
      downloadCSV(filename, rows);
      setValidationModal(null);
      setValidationData(null);
      doGrant();
      return;
    }

    if (choice === 'filterGrant') {
      // 下载重复 CSV（过滤已赠送）
      const label = data.type === 'user' ? '用户' : '设备';
      const filename = `已赠送${label}_过滤_${timestamp()}.csv`;
      const rows = [
        ['License', '已赠送次数', '当前赠送'],
        ...data.dupItems.map((item, i) => { const count = item.existingCount; return [(i + 1), count, count > 0 ? 0 : 1]; }),
        ...data.cleanItems.map((item, i) => [data.dupItems.length + i + 1, 0, 1]),
      ];
      downloadCSV(filename, rows);
      setValidationModal(null);
      setValidationData(null);

      if (data.cleanCount === 0) {
        message.info('过滤后无可开通目标，未执行开通操作');
        return;
      }
      doGrant();
      return;
    }
  };

  // 执行开通
  const doGrant = () => {
    setSubmitting(true);
    setTimeout(() => {
      message.success('套餐开通成功');
      setSubmitting(false);
      setAddDrawerVisible(false);
      setSelectedWorkOrderId(null);
      setLicenseList([]);
      setHandleMethod('manual');
      addForm.resetFields();
    }, 500);
  };

  const handleSubmit = () => {
    if (handleMethod === 'order') {
      if (!selectedWorkOrderId) { message.warning('请先选择生产工单'); return; }
      if (!selectedWorkOrder || selectedWorkOrder.licenseTotal === 0) { message.warning('该工单下暂无 License，请选择其他工单'); return; }
    }
    addForm.validateFields().then(() => {
      if (handleMethod === 'order') {
        // 按工单模式：二次确认 → 校验流水线
        setConfirmModalVisible(true);
      } else {
        // 手动/文件模式：直接进入校验流水线
        runValidation();
      }
    }).catch(() => {});
  };

  const handleConfirmSubmit = () => {
    setConfirmModalVisible(false);
    runValidation();
  };

  const getStatusTag = (status) => {
    const map = {
      produced: { color: 'green', text: '已生产' },
      pending: { color: 'default', text: '待生产' },
    };
    const c = map[status] || { color: 'default', text: status };
    return <Tag color={c.color} style={{ border: 'none' }}>{c.text}</Tag>;
  };

  // ═══════════ 取消开通（撤回）逻辑 ═══════════
  const openDetail = (record) => {
    setCurrentRow(record);
    setSelectedCancelKeys([]);
    setDrawerVisible(true);
  };

  const isBatchCancellable = (record) =>
    record?.opType === 'grant' && record?.effectiveType === 'later' && (record?.countWaiting || 0) > 0;

  const handleBatchCancel = (record) => {
    const cnt = record.countWaiting || 0;
    Modal.confirm({
      title: '确认取消开通？',
      content: `将撤回该批次 ${cnt} 条待开通记录。`,
      okText: '确认取消',
      okButtonProps: { danger: true },
      cancelText: '取消',
      onOk: () => {
        setBatchList(prev => prev.map(b => {
          if (b.id !== record.id) return b;
          const totalCancelled = (b.countCancelled || 0) + cnt;
          const allCancelled = (b.countOpened || 0) === 0 && (b.countFailed || 0) === 0 && totalCancelled === (b.countTotal || 0);
          return { ...b, countWaiting: 0, countCancelled: totalCancelled, batchStatus: allCancelled ? 'cancelled' : b.batchStatus };
        }));
        setDetailList(prev => prev.map(d => (d.batchId === record.id && d.status === 'waiting') ? { ...d, status: 'cancelled' } : d));
        message.success('取消开通成功');
      },
    });
  };

  const handleDetailCancel = () => {
    if (selectedCancelKeys.length === 0) return;
    const currentBatchId = currentRow?.id;
    const cnt = selectedCancelKeys.length;
    Modal.confirm({
      title: '确认取消开通？',
      content: `将撤回选中的 ${cnt} 条待开通记录。`,
      okText: '确认取消',
      okButtonProps: { danger: true },
      cancelText: '取消',
      onOk: () => {
        setDetailList(prev => prev.map(d => selectedCancelKeys.includes(d.id) ? { ...d, status: 'cancelled' } : d));
        if (currentBatchId) {
          setBatchList(prev => prev.map(b => {
            if (b.id !== currentBatchId) return b;
            const totalCancelled = (b.countCancelled || 0) + cnt;
            const remainWaiting = Math.max((b.countWaiting || 0) - cnt, 0);
            const allCancelled = (b.countOpened || 0) === 0 && (b.countFailed || 0) === 0 && remainWaiting === 0 && totalCancelled === (b.countTotal || 0);
            return { ...b, countWaiting: remainWaiting, countCancelled: totalCancelled, batchStatus: allCancelled ? 'cancelled' : b.batchStatus };
          }));
        }
        setSelectedCancelKeys([]);
        message.success('取消开通成功');
      },
    });
  };

  const columns = [
    { title: '序号', dataIndex: 'id', key: 'id', width: 60, align: 'center' },
    { title: '套餐信息', key: 'pkgInfo', width: 200, render: (_, record) => (<div><div style={{ fontWeight: 500, color: '#262626', marginBottom: 4 }}>{record.packageName}</div><div style={{ fontSize: 12, color: '#8c8c8c' }}>ID: {record.packageId}</div></div>) },
    { title: '应用方向', dataIndex: 'direction', key: 'direction', width: 100, render: (dir, record) => (<div style={{ paddingLeft: 4 }}><div style={{ color: '#262626', marginBottom: 2 }}>{dir === 'user' ? '用户方向' : '设备方向'}</div><div style={{ fontSize: 11, color: '#8c8c8c' }}>{record.idType?.toUpperCase() || (dir === 'user' ? 'ACCOUNT' : 'DID')}</div></div>) },
    { title: '操作类型', dataIndex: 'opType', width: 140, render: (type, record) => {
      if (type === 'close') return <Tag color="error">关闭套餐</Tag>;
      return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 4 }}>
          <Tag color="success">开通套餐</Tag>
          <span style={{ fontSize: 12, color: '#8c8c8c' }}>
            {record.effectiveType === 'later' ? '后生效(用户绑定后)' : '立即生效'}
          </span>
        </div>
      );
    } },
    { title: '来源类型', dataIndex: 'sourceType', key: 'sourceType', width: 120, render: (type, record) => {
      if (record.opType === 'close') return <span style={{ color: '#ccc' }}>--</span>;
      if (type === 'order') return <Tag color="blue" style={{ border: 'none' }}>按工单赠送</Tag>;
      if (type === 'manual') return <span style={{ color: '#8c8c8c' }}>手动赠送</span>;
      return <span style={{ color: '#ccc' }}>--</span>;
    }},
    { title: '来源工单', key: 'sourceOrder', width: 180, render: (_, record) => {
      if (record.opType === 'close') return <span style={{ color: '#ccc' }}>--</span>;
      if (record.sourceType === 'order' && record.sourceOrderId) return (
        <Button type="link" style={{ padding: 0, height: 'auto', textAlign: 'left' }} onClick={() => window.open(`/production/productionOrder/detail?id=${record.sourceOrderId}`, '_blank')}>
          <div>
            <div style={{ fontWeight: 500, fontSize: 13 }}>{record.sourceOrderName}</div>
            <div style={{ fontSize: 12, color: '#8c8c8c', fontFamily: 'monospace' }}>{record.sourceOrderId}</div>
          </div>
        </Button>
      );
      return <span style={{ color: '#ccc' }}>--</span>;
    }},
    { title: '设备/用户数', key: 'deviceCount', width: 160, render: (_, record) => {
      if (record.opType === 'close') return <Button type="link" style={{ fontWeight: 'bold', padding: 0 }} onClick={() => openDetail(record)}>{record.deviceCount}</Button>;
      const items = [
        { label: '已开通', value: record.countOpened ?? 0, color: '#52c41a' },
        { label: '待开通', value: record.countWaiting ?? 0, color: '#faad14' },
        { label: '开通失败', value: record.countFailed ?? 0, color: '#ff4d4f' },
        { label: '取消开通', value: record.countCancelled ?? 0, color: '#8c8c8c' },
      ];
      return (
        <div>
          <Button type="link" style={{ fontWeight: 'bold', padding: 0, fontSize: 14, height: 'auto' }} onClick={() => openDetail(record)}>共 {record.countTotal ?? 0}</Button>
          <div style={{ fontSize: 12, color: '#595959', lineHeight: 1.7 }}>
            {items.map(it => (<div key={it.label}><span style={{ color: it.color, marginRight: 4 }}>●</span>{it.label} {it.value}</div>))}
          </div>
        </div>
      );
    } },
    { title: '备注说明', dataIndex: 'memo', key: 'memo', ellipsis: true },
    { title: '操作人', dataIndex: 'operator', key: 'operator', render: (op) => <span>{op}</span> },
    { title: '操作时间', dataIndex: 'time', key: 'time', render: (t) => <span>{t}</span> },
    { title: '操作', key: 'action', width: 100, fixed: 'right', render: (_, record) => {
      if (!isBatchCancellable(record)) return <span style={{ color: '#ccc' }}>--</span>;
      return <Button type="link" danger size="small" onClick={() => handleBatchCancel(record)}>取消开通</Button>;
    } },
  ];

  const getBatchDetailColumns = (batch) => {
    const idTypeLabel = batch?.idType?.toUpperCase() || 'LICENSE';
    return [
      { title: '序号', dataIndex: 'id', key: 'id', width: 60, align: 'center', render: (_, __, i) => i + 1 },
      { title: idTypeLabel, key: 'identifier', render: (_, record) => record.license || record.did || record.uid || record.account || '--' },
      { title: '开通状态', dataIndex: 'status', key: 'status', render: (s) => {
        const config = { opened: { status: 'success', text: '已开通' }, waiting: { status: 'warning', text: '待开通' }, failed: { status: 'error', text: '开通失败' }, cancelled: { status: 'default', text: '取消开通' } };
        const c = config[s] || { status: 'default', text: s };
        return <Badge status={c.status} text={c.text} />;
      }},
      { title: '订单号', dataIndex: 'orderNo', key: 'orderNo', ellipsis: true, render: (text) => text || <span style={{ color: '#ccc' }}>--</span> },
    ];
  };

  return (
    <Layout style={{ padding: '20px', background: '#fff' }}>
      <Content>
        <div style={{ background: '#fffbe6', border: '1px solid #ffe58f', padding: '12px 16px', borderRadius: '4px', marginBottom: '20px' }}>
          <Space align="start">
            <InfoCircleOutlined style={{ color: '#faad14', marginTop: '4px' }} />
            <div>
              <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>警告提示</div>
              <div style={{ fontSize: '13px', color: 'rgba(0, 0, 0, 0.85)', lineHeight: '1.8' }}>
                1、此页面功能主要用于售后阶段（针对已出货设备）补开增值服务，并非用于常规套餐开通；<br />
                2、<strong>该功能会产生费用，每次开通都会扣除对应的套餐底价（扣除企业余额），请务必确保您的企业余额充足，否则将会影响平台、APP和设备的相关服务使用</strong>；<br />
              </div>
            </div>
          </Space>
        </div>

        <div style={{ marginBottom: '20px' }}>
          <Space><Button type="primary" onClick={() => { setAddDrawerVisible(true); setHandleMethod('manual'); }}>套餐开通</Button><Button danger onClick={() => { setCloseDrawerVisible(true); setCloseTargetId(''); setCloseTargetInfo(null); setCloseQueryResult([]); }}>关闭套餐</Button></Space>
        </div>

        <Card bodyStyle={{ padding: '16px 24px 0 24px' }} style={{ marginBottom: '16px', border: 'none', background: '#fcfcfc' }}>
          <Form form={form} layout="inline" style={{ gap: '16px 0' }}>
            <Form.Item name="identifier"><Input placeholder="请输入License/DID/UID/账号" allowClear style={{ width: 220 }} /></Form.Item>
            <Form.Item>
              <Form.Item shouldUpdate={(p, c) => p.pkgSearchType !== c.pkgSearchType} noStyle>
                {({ getFieldValue }) => {
                  const type = getFieldValue('pkgSearchType') || 'name';
                  return (
                    <Space.Compact style={{ width: '100%' }}>
                      <Form.Item name="pkgSearchType" initialValue="name" noStyle>
                        <Select style={{ width: 100 }}>
                          <Option value="name">套餐名称</Option>
                          <Option value="id">套餐ID</Option>
                        </Select>
                      </Form.Item>
                      <Form.Item name="pkgName" noStyle>
                        <Input placeholder={type === 'name' ? '套餐名称' : '套餐ID'} style={{ width: 180 }} allowClear />
                      </Form.Item>
                    </Space.Compact>
                  );
                }}
              </Form.Item>
            </Form.Item>
            <Form.Item>
              <Form.Item shouldUpdate={(p, c) => p.orderSearchType !== c.orderSearchType} noStyle>
                {({ getFieldValue }) => {
                  const type = getFieldValue('orderSearchType') || 'name';
                  return (
                    <Space.Compact style={{ width: '100%' }}>
                      <Form.Item name="orderSearchType" initialValue="name" noStyle>
                        <Select style={{ width: 100 }}>
                          <Option value="name">工单名称</Option>
                          <Option value="id">工单ID</Option>
                        </Select>
                      </Form.Item>
                      <Form.Item name="orderSearch" noStyle>
                        <Input placeholder={type === 'name' ? '工单名称' : '工单ID'} style={{ width: 180 }} allowClear />
                      </Form.Item>
                    </Space.Compact>
                  );
                }}
              </Form.Item>
            </Form.Item>
            <Form.Item name="range"><RangePicker style={{ width: 260 }} placeholder={['开始时间', '结束时间']} /></Form.Item>
            <Form.Item><Space><Button type="primary" icon={<SearchOutlined />} htmlType="submit">查询</Button><Button icon={<ReloadOutlined />}>重置</Button></Space></Form.Item>
          </Form>
        </Card>

        <Table columns={columns} dataSource={batchList} rowKey="id" scroll={{ x: 1500 }} pagination={{ showSizeChanger: true, showQuickJumper: true, total: batchList.length, showTotal: (total) => `共 ${total} 条` }} />

        <Drawer title={<Space><HistoryOutlined style={{ color: '#1890ff' }} /><span>开通详情</span></Space>} width="50%" open={drawerVisible} onClose={() => { setDrawerVisible(false); setSelectedCancelKeys([]); }} destroyOnClose>
          {currentRow && (<>
            <div style={{ background: '#f8fafc', padding: '20px', borderRadius: 12, border: '1px solid #e2e8f0', marginBottom: 24 }}>
              <Descriptions bordered size="small" column={2}>
                <Descriptions.Item label="套餐名称">{currentRow.packageName}</Descriptions.Item>
                <Descriptions.Item label="套餐ID">{currentRow.packageId}</Descriptions.Item>
                <Descriptions.Item label="应用方向"><div style={{ color: '#262626' }}>{currentRow.direction === 'user' ? '用户方向' : '设备方向'}<span style={{ margin: '0 8px', color: '#bfbfbf' }}>—</span><span style={{ fontSize: 13, color: '#8c8c8c', textTransform: 'uppercase' }}>{currentRow.idType || 'LICENSE'}</span></div></Descriptions.Item>
                <Descriptions.Item label="生效方式">{currentRow.effectiveType === 'later' ? '后生效(用户绑定后)' : '立即生效'}</Descriptions.Item>
                <Descriptions.Item label="设备/用户数"><Text strong>{currentRow.opType === 'close' ? currentRow.deviceCount : currentRow.countTotal}</Text></Descriptions.Item>
                <Descriptions.Item label="操作人">{currentRow.operator}</Descriptions.Item>
                {currentRow.sourceType === 'order' && (<Descriptions.Item label="来源工单" span={2}><Button type="link" style={{ padding: 0 }} onClick={() => window.open(`/production/productionOrder/detail?id=${currentRow.sourceOrderId}`, '_blank')}>{currentRow.sourceOrderName} ({currentRow.sourceOrderId})</Button></Descriptions.Item>)}
                <Descriptions.Item label="操作时间" span={2}>{currentRow.time}</Descriptions.Item>
              </Descriptions>
            </div>
            <div style={{ marginBottom: 24, padding: '16px', background: '#fff', borderRadius: 8, border: '1px solid #f0f0f0' }}><Space size={16}><Input placeholder="请输入License/DID/UID/账号" style={{ width: 320 }} allowClear prefix={<SearchOutlined style={{ color: '#bfbfbf' }} />} /><Button type="primary">查询</Button><Button icon={<ReloadOutlined />}>重置</Button></Space></div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
              <Title level={4} style={{ margin: 0 }}>明细列表</Title>
              {currentRow?.opType !== 'close' && currentRow?.effectiveType === 'later' && (
                <Button danger disabled={selectedCancelKeys.length === 0} onClick={handleDetailCancel}>取消开通</Button>
              )}
            </div>
            <Table
              rowSelection={currentRow?.opType !== 'close' && currentRow?.effectiveType === 'later' ? {
                selectedRowKeys: selectedCancelKeys,
                onChange: setSelectedCancelKeys,
                getCheckboxProps: (record) => ({ disabled: !(record.effectiveType === 'later' && record.status === 'waiting') }),
              } : undefined}
              columns={getBatchDetailColumns(currentRow)}
              dataSource={detailList.filter(d => d.batchId === currentRow?.id)}
              rowKey="id"
              size="small"
              pagination={{ pageSize: 10 }}
            />
          </>)}
        </Drawer>

        {/* 开通套餐抽屉 */}
        <Drawer
          title={<Space><PlusOutlined style={{ color: '#1890ff' }} /><span>套餐开通</span></Space>}
          width={800} open={addDrawerVisible}
          onClose={() => { setAddDrawerVisible(false); setSelectedWorkOrderId(null); setHandleMethod('manual'); }}
          destroyOnClose
          footer={<div style={{ textAlign: 'right' }}><Button onClick={() => { setAddDrawerVisible(false); setSelectedWorkOrderId(null); setHandleMethod('manual'); }} style={{ marginRight: 8 }} disabled={validating || submitting}>取消</Button><Button type="primary" onClick={handleSubmit} loading={validating || submitting}>{validating ? '校验中...' : submitting ? '开通中...' : '确认开通'}</Button></div>}
        >
          <div style={{ padding: '0 12px' }}>
            <Alert message="温馨提示" description="开通(赠送)套餐将会扣除套餐底价，请确保企业余额充足，欠费将会影响平台服务使用。" type="warning" showIcon style={{ marginBottom: 24, borderRadius: 8 }} />
            <Form form={addForm} layout="vertical">
              <div style={{ background: '#f8f9fa', padding: '24px', borderRadius: 12, border: '1px solid #f0f0f0', marginBottom: 24 }}>
                <Row gutter={24} style={{ marginBottom: 20 }}>
                  <Col span={12}>
                    <Form.Item label={<Text strong>应用方向</Text>} required>
                      <Radio.Group value={direction} onChange={e => { const val = e.target.value; setDirection(val); setIdType(val === 'device' ? 'license' : 'uid'); if (val === 'user') addForm.setFieldsValue({ effectiveType: 'immediate' }); }} optionType="button" buttonStyle="solid" style={{ width: '100%' }}>
                        <Radio.Button value="device" style={{ width: '50%', textAlign: 'center' }}>设备</Radio.Button><Radio.Button value="user" style={{ width: '50%', textAlign: 'center' }}>用户</Radio.Button>
                      </Radio.Group>
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item label={<Text strong>标识类型</Text>} required>
                      <Radio.Group value={idType} onChange={e => setIdType(e.target.value)} optionType="button" buttonStyle="solid" style={{ width: '100%' }}>
                        {direction === 'device' ? (<><Radio.Button value="license" style={{ width: '50%', textAlign: 'center' }}>License</Radio.Button><Radio.Button value="did" style={{ width: '50%', textAlign: 'center' }}>DID</Radio.Button></>) : (<><Radio.Button value="uid" style={{ width: '25%', textAlign: 'center' }}>UID</Radio.Button><Radio.Button value="account" style={{ width: '25%', textAlign: 'center' }}>账号</Radio.Button><Radio.Button value="license" style={{ width: '25%', textAlign: 'center' }}>License</Radio.Button><Radio.Button value="did" style={{ width: '25%', textAlign: 'center' }}>DID</Radio.Button></>)}
                      </Radio.Group>
                    </Form.Item>
                  </Col>
                </Row>
                <Divider style={{ margin: '0 0 20px' }} />

                <Form.Item label={<Text strong>处理方式</Text>} required>
                  <Radio.Group value={handleMethod} onChange={handleMethodChange} style={{ display: 'flex', gap: 16 }}>
                    <Radio value="manual">手动输入</Radio>
                    <Radio value="import">文件导入</Radio>
                    <Radio value="order">按工单选择</Radio>
                  </Radio.Group>
                </Form.Item>

                <div style={{ marginTop: 16 }}>
                  {handleMethod === 'manual' && (
                    <Form.Item label={<Text strong>{idType.toUpperCase()} 标识输入</Text>} name="targetIds" rules={[{ required: true, message: `请输入${idType.toUpperCase()}` }]} extra={<Text type="secondary" style={{ fontSize: 12 }}>支持批量录入，每行一个标识符。</Text>}>
                      <Input.TextArea placeholder={`请输入待开通的 ${idType.toUpperCase()}...`} rows={6} allowClear style={{ background: '#fff' }} />
                    </Form.Item>
                  )}
                  {handleMethod === 'import' && (
                    <div style={{ padding: '24px', background: '#fff', border: '1px dashed #d9d9d9', borderRadius: 8, textAlign: 'center' }}>
                      <Space direction="vertical" size="middle" style={{ width: '100%' }}>
                        <CloudUploadOutlined style={{ fontSize: 32, color: '#1890ff' }} />
                        <Upload accept=".csv,.xlsx" maxCount={1} beforeUpload={() => false} showUploadList={true}><Button type="primary" ghost icon={<UploadOutlined />}>选取 {idType.toUpperCase()} 数据文件</Button></Upload>
                        <div style={{ fontSize: 12, color: '#8c8c8c' }}>请上传大小不超过 <span style={{ color: '#ff4d4f' }}>10MB</span> 格式为 <span style={{ color: '#ff4d4f' }}>xlsx/xls</span> 的文件</div>
                        <Button type="link" icon={<DownloadOutlined />} style={{ padding: 0 }}>下载标准模板</Button>
                      </Space>
                    </div>
                  )}
                  {handleMethod === 'order' && (
                    <div>
                      <Form.Item label={<Text strong>选择生产工单</Text>}>
                        <Select
                          showSearch
                          placeholder="请选择生产工单"
                          value={selectedWorkOrderId}
                          onChange={handleOrderSelect}
                          filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase())}
                          options={MOCK_WORK_ORDERS.map(formatWorkOrderOption)}
                          style={{ width: '100%' }}
                        />
                      </Form.Item>
                      {selectedWorkOrderId && (
                        <div style={{ marginBottom: 16, padding: '10px 14px', background: '#f0f5ff', borderRadius: 6, border: '1px solid #d6e4ff', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                          <Text>已选工单：<Text code strong>{selectedWorkOrderId}</Text><Text type="secondary" style={{ marginLeft: 8 }}>| {selectedWorkOrder?.name} | {selectedWorkOrder?.productName} | License: {selectedWorkOrder?.licenseTotal}个</Text></Text>
                          <Button type="link" size="small" onClick={() => { setSelectedWorkOrderId(null); setLicenseList([]); }}>清除</Button>
                        </div>
                      )}

                      {selectedWorkOrder && (
                        <div style={{ background: '#fff', padding: '16px', borderRadius: 8, border: '1px solid #f0f0f0' }}>
                          <div style={{ marginBottom: 12 }}>
                            <Text strong style={{ fontSize: 14 }}>License 开通预览</Text>
                            <div style={{ marginTop: 4 }}><Text>共 <Text strong>{selectedWorkOrder.licenseTotal}</Text> 个 License，将全部用于本次赠送</Text></div>
                          </div>
                          <Table columns={[
                            { title: '序号', dataIndex: 'id', key: 'id', width: 60, align: 'center' },
                            { title: 'License ID', dataIndex: 'licenseId', key: 'licenseId', render: (t) => <Text code style={{ fontSize: 12 }}>{t}</Text> },
                            { title: '状态', dataIndex: 'status', key: 'status', render: (s) => getStatusTag(s) },
                          ]} dataSource={licenseList} rowKey="id" size="small" loading={licenseLoading} pagination={{ pageSize: 10, showSizeChanger: false, showTotal: (t) => `共 ${t} 条` }} scroll={{ y: 300 }} />
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>

              <Form.Item label={<Text strong>生效方式</Text>} required name="effectiveType" initialValue="immediate">
                <Radio.Group disabled={direction === 'user'}><Radio value="immediate">立即生效</Radio><Radio value="later">后生效（用户绑定后）</Radio></Radio.Group>
              </Form.Item>

              <Form.Item label={<Text strong>选择套餐</Text>} required>
                <Form.Item shouldUpdate={(p, c) => p.pkgSearchType !== c.pkgSearchType} noStyle>
                  {({ getFieldValue }) => {
                    const searchType = getFieldValue('pkgSearchType') || 'name';
                    return (
                      <Space.Compact style={{ width: '100%' }}>
                        <Form.Item name="pkgSearchType" initialValue="name" noStyle><Select style={{ width: 120 }}><Option value="name">套餐名称</Option><Option value="id">套餐ID</Option></Select></Form.Item>
                        {searchType === 'name' ? (
                          <Form.Item name="targetPkg" rules={[{ required: true, message: '请选择套餐' }]} noStyle><Select placeholder="请选择套餐名称" showSearch style={{ flex: 1 }}><Option value="1">超高清录像 7天循环 (365天包)</Option><Option value="2">AI人脸识别 (按月订阅)</Option><Option value="3">移动侦测-测试专供</Option></Select></Form.Item>
                        ) : (
                          <Form.Item name="targetPkgId" rules={[{ required: true, message: '请输入套餐ID' }]} noStyle><Input placeholder="请输入套餐ID" style={{ flex: 1 }} /></Form.Item>
                        )}
                      </Space.Compact>
                    );
                  }}
                </Form.Item>
              </Form.Item>

              <Form.Item label={<Text strong>备注</Text>} name="memo">
                <Input.TextArea placeholder="请输入赠送用途，如：售后补偿、活动促销等" rows={3} showCount maxLength={200} />
              </Form.Item>

              {/* ═══════════ Mock 弹窗演示按钮（仅开发环境，后续删除） ═══════════ */}
              <div style={{ marginTop: 16, padding: '12px 16px', background: '#fffbe6', borderRadius: 8, border: '1px solid #ffe58f' }}>
                <div style={{ fontSize: 12, color: '#8c8c8c', marginBottom: 8 }}>🧪 Mock 弹窗演示（点击直接预览校验弹窗效果）</div>
                <Space wrap>
                  <Button size="small" onClick={() => {
                    setValidationData({ type: 'device', illegalCount: 3, validCount: 3, illegalItems: makeMockIllegalItems(idType.toUpperCase(), 3), validItems: makeMockValidItems(idType.toUpperCase(), 3) });
                    setValidationModal('illegalDevice');
                  }}>弹窗A：非法设备</Button>
                  <Button size="small" onClick={() => {
                    setValidationData({ type: 'user', illegalCount: 3, validCount: 3, illegalItems: makeMockIllegalItems('USER', 3), validItems: makeMockValidItems('USER', 3) });
                    setValidationModal('illegalUser');
                  }}>弹窗B：非法用户</Button>
                  <Button size="small" onClick={() => {
                    const dupItems = makeMockDupItems(idType.toUpperCase(), 3);
                    const cleanItems = makeMockValidItems(idType.toUpperCase(), 2);
                    setValidationData({ type: 'device', duplicateCount: dupItems.length, cleanCount: cleanItems.length, totalCount: dupItems.length + cleanItems.length, dupItems, cleanItems });
                    setValidationModal('duplicate');
                  }}>弹窗C：重复赠送</Button>
                  <Button size="small" danger type="dashed" onClick={() => {
                    setValidationData({ type: 'device', illegalCount: 5, validCount: 0, illegalItems: makeMockIllegalItems(idType.toUpperCase(), 5), validItems: [] });
                    setValidationModal('illegalDevice');
                  }}>弹窗A - 无有效(置灰)</Button>
                  <Button size="small" danger type="dashed" onClick={() => {
                    const dupItems = makeMockDupItems(idType.toUpperCase(), 5);
                    setValidationData({ type: 'device', duplicateCount: dupItems.length, cleanCount: 0, totalCount: dupItems.length, dupItems, cleanItems: [] });
                    setValidationModal('duplicate');
                  }}>弹窗C - 全是重复(置灰)</Button>
                </Space>
              </div>
            </Form>
          </div>
        </Drawer>

        {/* ═══════════ 关闭套餐 Drawer ═══════════ */}
        <Drawer
          title={<Space><span style={{ color: '#ff4d4f', fontWeight: 600 }}>关闭套餐</span></Space>}
          width={900} open={closeDrawerVisible}
          onClose={() => { setCloseDrawerVisible(false); setCloseTargetInfo(null); setCloseQueryResult([]); }}
          destroyOnClose
        >
          <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
            <div style={{ padding: '20px', background: '#f8fafc', borderRadius: 12, border: '1px solid #e2e8f0' }}>
              <div style={{ marginBottom: 16 }}>
                <Radio.Group value={closeTargetType} onChange={e => { const v = e.target.value; setCloseTargetType(v); setCloseIdType(v === 'device' ? 'license' : 'account'); setCloseTargetInfo(null); setCloseQueryResult([]); }} optionType="button" buttonStyle="solid">
                  <Radio.Button value="device">关闭设备套餐</Radio.Button>
                  <Radio.Button value="user">关闭用户套餐</Radio.Button>
                </Radio.Group>
              </div>
              <Space>
                <Radio.Group value={closeIdType} onChange={e => setCloseIdType(e.target.value)}>
                  {closeTargetType === 'device' ? (<><Radio value="license">License</Radio><Radio value="did">设备DID</Radio></>) : (<><Radio value="account">账号</Radio><Radio value="uid">UID</Radio></>)}
                </Radio.Group>
                <Input
                  placeholder={`请输入${closeIdType.toUpperCase()}...`}
                  value={closeTargetId} onChange={e => setCloseTargetId(e.target.value)}
                  style={{ width: 280 }} allowClear onPressEnter={handleCloseQuery}
                />
                <Button type="primary" onClick={handleCloseQuery} loading={closeQueryLoading}>查询套餐</Button>
              </Space>
            </div>

            {closeQueryLoading && <div style={{ textAlign: 'center', padding: 40 }}><Spin tip="查询中..." /></div>}

            {!closeQueryLoading && closeTargetInfo && (
              <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                {closeTargetType === 'device' && (
                  <Descriptions title="设备基础信息" bordered size="small" column={2}>
                    <Descriptions.Item label="设备DID">{closeTargetInfo.did}</Descriptions.Item>
                    <Descriptions.Item label="License">{closeTargetInfo.license}</Descriptions.Item>
                    <Descriptions.Item label="所属企业">{closeTargetInfo.enterprise}</Descriptions.Item>
                    <Descriptions.Item label="企业ID">{closeTargetInfo.enterpriseId}</Descriptions.Item>
                  </Descriptions>
                )}
                {closeTargetType === 'user' && (
                  <Descriptions title="用户基础信息" bordered size="small" column={2}>
                    <Descriptions.Item label="UID">{closeTargetInfo.uid}</Descriptions.Item>
                    <Descriptions.Item label="账号">{closeTargetInfo.account}</Descriptions.Item>
                  </Descriptions>
                )}
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <Title level={4} style={{ margin: 0 }}>有效套餐列表</Title>
                  <Button danger disabled={closeSelectedKeys.length === 0} onClick={() => {
                    Modal.confirm({ title: '确认关闭选中的套餐?', content: '关闭后不可恢复。', onOk: () => { message.success('批量关闭成功'); setCloseQueryResult(prev => prev.filter(p => !closeSelectedKeys.includes(p.id))); setCloseSelectedKeys([]); } });
                  }}>批量关闭</Button>
                </div>
                <Table
                  rowSelection={{ selectedRowKeys: closeSelectedKeys, onChange: setCloseSelectedKeys }}
                  columns={[
                    { title: '套餐信息', key: 'pkgInfo', render: (_, r) => (<div><div style={{ fontWeight: 500 }}>{r.packageName}</div><div style={{ fontSize: 12, color: '#8c8c8c' }}>ID: {r.packageId}</div></div>) },
                    { title: '操作类型', dataIndex: 'opType', width: 130, render: (_, record) => (
                      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 4 }}>
                        <Tag color="success">开通套餐</Tag>
                        <span style={{ fontSize: 12, color: '#8c8c8c' }}>
                          {record.effectiveType === 'later' ? '后生效(用户绑定后)' : '立即生效'}
                        </span>
                      </div>
                    ) },
                    { title: '订单号', dataIndex: 'orderNo', key: 'orderNo' },
                    { title: '服务时长', dataIndex: 'duration', key: 'duration' },
                    { title: '状态', dataIndex: 'status', key: 'status', render: (s) => <Badge status={s === 'pending' ? 'processing' : 'success'} text={s === 'pending' ? '待生效' : '生效中'} /> },
                    { title: '购买时间', dataIndex: 'buyTime', key: 'buyTime' },
                    { title: '失效时间', dataIndex: 'expireTime', key: 'expireTime' },
                    { title: '操作', key: 'action', render: (_, r) => (
                      <Button type="link" danger size="small" onClick={() => {
                        Modal.confirm({ title: '确认关闭该套餐?', onOk: () => { message.success('关闭成功'); setCloseQueryResult(prev => prev.filter(p => p.id !== r.id)); } });
                      }}>关闭</Button>
                    )},
                  ]}
                  dataSource={closeQueryResult}
                  rowKey="id"
                  size="small"
                  pagination={{ pageSize: 5, showSizeChanger: true, showTotal: (t) => `共 ${t} 条记录` }}
                />
              </div>
            )}

            {!closeQueryLoading && !closeTargetInfo && !closeTargetId && (
              <Empty description="请输入标识并查询套餐" />
            )}
            {!closeQueryLoading && !closeTargetInfo && closeTargetId && (
              <Empty description="该目标暂无生效中或待生效的套餐" />
            )}
          </div>
        </Drawer>

        <Modal title="确认赠送套餐？" open={confirmModalVisible} onCancel={() => setConfirmModalVisible(false)} onOk={handleConfirmSubmit} okText="确认赠送" cancelText="取消" width={480}>
          <div style={{ lineHeight: 2 }}>
            <Descriptions column={1} size="small" colon={false}>
              <Descriptions.Item label={<Text type="secondary">套餐</Text>}><Text strong>超高清录像 7天循环 (365天包)</Text></Descriptions.Item>
              <Descriptions.Item label={<Text type="secondary">赠送范围</Text>}><Text>工单「{selectedWorkOrder?.name}」下 {selectedWorkOrder?.licenseTotal} 个 License</Text></Descriptions.Item>
              <Descriptions.Item label={<Text type="secondary">生效方式</Text>}><Text>{addForm.getFieldValue('effectiveType') === 'later' ? '后生效（用户绑定后）' : '立即生效'}</Text></Descriptions.Item>
            </Descriptions>
            <Alert message="赠送后不可撤销，确认继续？" type="warning" showIcon style={{ marginTop: 12 }} />
          </div>
        </Modal>

        {/* ═══════════ 弹窗A：非法设备处理 ═══════════ */}
        <Modal
          title="存在非法 License"
          open={validationModal === 'illegalDevice'}
          closable={false}
          maskClosable={false}
          footer={
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
              <Button onClick={() => handleValidationChoice('cancel')}>取消</Button>
              <Button onClick={() => handleValidationChoice('downloadOnly')}>仅下载错误设备</Button>
              <Button
                type="primary"
                disabled={validationData?.validCount === 0}
                onClick={() => handleValidationChoice('continueValid')}
              >开通有效设备</Button>
            </div>
          }
          width={520}
        >
          <div style={{ lineHeight: 2 }}>
            <Alert
              message={`已识别 ${validationData?.illegalCount || 0} 条非法 License/DID，可一键过滤非法设备再继续开通，请选择处理方案。`}
              type="warning"
              showIcon
              style={{ marginBottom: 16, borderRadius: 8 }}
            />
            <Descriptions column={2} size="small" bordered>
              <Descriptions.Item label="非法 License 数量">
                <Text strong style={{ color: '#ff4d4f', fontSize: 16 }}>{validationData?.illegalCount || 0}</Text>
              </Descriptions.Item>
              <Descriptions.Item label="有效 License 数量">
                <Text strong style={{ color: '#52c41a', fontSize: 16 }}>{validationData?.validCount || 0}</Text>
              </Descriptions.Item>
            </Descriptions>
            {validationData?.validCount === 0 && (
              <Alert message="无有效设备可开通，请检查并修改后重试" type="error" showIcon style={{ marginTop: 12, borderRadius: 8 }} />
            )}
          </div>
        </Modal>

        {/* ═══════════ 弹窗B：非法用户处理 ═══════════ */}
        <Modal
          title="存在用户跨域或用户不存在"
          open={validationModal === 'illegalUser'}
          closable={false}
          maskClosable={false}
          footer={
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
              <Button onClick={() => handleValidationChoice('cancel')}>取消</Button>
              <Button onClick={() => handleValidationChoice('downloadOnly')}>仅下载错误用户</Button>
              <Button
                type="primary"
                disabled={validationData?.validCount === 0}
                onClick={() => handleValidationChoice('continueValid')}
              >开通有效用户</Button>
            </div>
          }
          width={520}
        >
          <div style={{ lineHeight: 2 }}>
            <Alert
              message={`已识别 ${validationData?.illegalCount || 0} 条非法用户，是否继续？`}
              type="warning"
              showIcon
              style={{ marginBottom: 16, borderRadius: 8 }}
            />
            <Descriptions column={2} size="small" bordered>
              <Descriptions.Item label="非法用户数量">
                <Text strong style={{ color: '#ff4d4f', fontSize: 16 }}>{validationData?.illegalCount || 0}</Text>
              </Descriptions.Item>
              <Descriptions.Item label="有效用户数量">
                <Text strong style={{ color: '#52c41a', fontSize: 16 }}>{validationData?.validCount || 0}</Text>
              </Descriptions.Item>
            </Descriptions>
            {validationData?.validCount === 0 && (
              <Alert message="无有效用户可开通，请检查并修改后重试" type="error" showIcon style={{ marginTop: 12, borderRadius: 8 }} />
            )}
          </div>
        </Modal>

        {/* ═══════════ 弹窗C：重复赠送处理 ═══════════ */}
        <Modal
          title={`存在已赠送过的${validationData?.type === 'user' ? '用户' : '设备'}`}
          open={validationModal === 'duplicate'}
          closable={false}
          maskClosable={false}
          footer={
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
              <Button onClick={() => handleValidationChoice('cancel')}>取消</Button>
              <Button onClick={() => handleValidationChoice('allGrant')}>全部开通</Button>
              <Button
                type="primary"
                disabled={validationData?.cleanCount === 0}
                onClick={() => handleValidationChoice('filterGrant')}
              >过滤已赠送开通</Button>
            </div>
          }
          width={520}
        >
          <div style={{ lineHeight: 2 }}>
            <Alert
              message={`已识别 ${validationData?.duplicateCount || 0} 条已赠送过的${validationData?.type === 'user' ? '用户' : '设备'}，请选择继续操作的功能。`}
              type="warning"
              showIcon
              style={{ marginBottom: 16, borderRadius: 8 }}
            />
            <Descriptions column={2} size="small" bordered>
              <Descriptions.Item label="已赠送过的数量">
                <Text strong style={{ color: '#faad14', fontSize: 16 }}>{validationData?.duplicateCount || 0}</Text>
              </Descriptions.Item>
              <Descriptions.Item label="未赠送的数量">
                <Text strong style={{ color: '#52c41a', fontSize: 16 }}>{validationData?.cleanCount || 0}</Text>
              </Descriptions.Item>
              <Descriptions.Item label="总计" span={2}>
                <Text strong style={{ fontSize: 14 }}>{(validationData?.duplicateCount || 0) + (validationData?.cleanCount || 0)}</Text>
              </Descriptions.Item>
            </Descriptions>
            {validationData?.cleanCount === 0 && (
              <Alert message="所有有效目标均已赠送过，建议选择全部开通" type="info" showIcon style={{ marginTop: 12, borderRadius: 8 }} />
            )}
          </div>
        </Modal>
      </Content>
    </Layout>
  );
};

export default PackageGift;
